export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';

  // Mobile filter (open/close)
  $(document).on('click', `[data-mobile-${prefix}filter-nav-options] [data-${prefix}filter-button]`, (e) => {
    const $item = $(e.currentTarget);
    const $option = $item.closest('li');
    const previous_state_active = $option.hasClass('active');

    $(`[data-mobile-${prefix}filter-nav-options] [data-${prefix}filter-options]`).removeClass('active');
    $(`[data-mobile-${prefix}filter-sorting]`).removeClass('active');

    if (!previous_state_active) {
      $option.addClass('active');
    }
  });

  $(document).on('click', `[data-mobile-filter-nav-done]`, (e) => {
    $(`[data-mobile-filter-nav-close]`).trigger('click');
  });

  $(document).on('click', `[data-mobile-${prefix}filter-sorting] [data-${prefix}filter-options-title]`, (e) => {
    const $item = $(e.currentTarget);
    const $option = $item.parent();
    const previous_state_active = $option.hasClass('active');

    $(`[data-mobile-${prefix}filter-nav-options] [data-${prefix}filter-options]`).removeClass('active');
    $(`[data-mobile-${prefix}filter-sorting]`).removeClass('active');

    if (!previous_state_active) {
      $option.addClass('active');
    }
  });

  /*
  // Keep this code - Ref: data-see-more-mobile-options
  $(document).on('click', '[data-see-more-mobile-options]', (e) => {
    const $item = $(e.currentTarget);

    $item.parent().find('[data-clickable-option-li]').removeClass('manually-hidden');
    $item.remove();
  });
  */

  $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
    if (current_breakpoint !== 'mobile' && $('html').hasClass('mobile-filter-nav-opened')) {
      $('[data-close-drawer]').trigger('click');
    }
  });
};
